import { render } from "./adminEditRedEnvelope.vue?vue&type=template&id=572a2d14"
import script from "./adminEditRedEnvelope.vue?vue&type=script&lang=js"
export * from "./adminEditRedEnvelope.vue?vue&type=script&lang=js"

import "./adminEditRedEnvelope.vue?vue&type=style&index=0&id=572a2d14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__